import styled from "styled-components";
import theme from "../../Themes/light";

const { colors } = theme;

export const FloatingButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  position: fixed;
  z-index: 50;
  width: auto;
  height: 8rem;
  padding: 2.4rem;
  border-radius: 32px;
  background-color: ${(props) => props.theme.colors.primary};
  bottom: 5rem;
  right: 5rem;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow:
    rgba(0, 0, 0, 0.2) 0px 3px 5px -1px,
    rgba(0, 0, 0, 0.14) 0px 6px 10px 0px,
    rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;
  transform: translateY(100%) translateX(25%) scale(0);

  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primary};
  }

  &.collapsed {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: smoothMorph 1s ease-in-out forwards;
    
    .mais {
      padding: 0;
      gap: 0;
      width: 100%;
      height: 100%;
      animation: textSlideOut 1s ease-in-out;
      
      .icone-floating {
        width: 24px;
        height: 24px;
        animation: iconCenter 1s ease-in-out;
      }
    }
  }

  @keyframes smoothMorph {
    0% {
      border-radius: 32px;
    }
    100% {
      border-radius: 50%;
    }
  }

  @keyframes textSlideOut {
    0% {
      gap: 10px;
      opacity: 1;
    }
    50% {
      gap: 5px;
      opacity: 0.8;
    }
    100% {
      gap: 0;
      opacity: 1;
    }
  }

  @keyframes iconCenter {
    0% {
      transform: translateX(0) scale(1);
    }
    50% {
      transform: translateX(-5px) scale(0.95);
    }
    100% {
      transform: translateX(0) scale(1);
    }
  }

  .mais{
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-direction: row;
    border-radius: 32px;
    height: 8rem;
    padding: 8px 16px;
    transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    
    .icone-floating {
      width: 18px;
      height: 18px;
      fill: ${colors.white};
      transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      flex-shrink: 0;
    }
  }

  @media (max-width: 1024px) {
    bottom: 14rem;
  }

  &.floating-ativo {
    transform: translateY(0%) translateX(0%) scale(1);

    .icone-floating {
      transform: translateY(0%) translateX(0%) scale(1);
      fill: ${colors.white};
    }
  }
  .seletor-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 5rem;
    height: 5rem;
    padding: 1.5rem;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.primary};
    bottom: 120%;
    transition: all 0.3s ease;
    box-shadow:
      rgba(0, 0, 0, 0.2) 0px 3px 5px -1px,
      rgba(0, 0, 0, 0.14) 0px 6px 10px 0px,
      rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;

    cursor: pointer;

    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
    }

    >.mais{
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.disable};
      display: flex;
      flex-direction: row;

      .icone-floating {
        width: 17px;
        transition: all 0.3s ease;
        fill: ${colors.white};
      }
    }
  }
`;
